module.exports = __webpack_public_path__ + "static/media/referral-promo.626b8458.webp";